import { elements } from '../periodicElements';
import { Link, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { handleElementClick, renderElementVideo, renderColumn } from '../FunctionsElements';
import { useTranslation } from 'react-i18next';

export default function AtomEconomy() {
  const [selectedElement, setSelectedElement] = useState(null);
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      {selectedElement ? (
        <section className="bg-background-secondary min-h-screen flex items-center justify-center p-4 transition-colors duration-300">
          <div className="flex items-center justify-center w-full max-w-4xl">
            {renderElementVideo(selectedElement, setSelectedElement, t, navigate)}
          </div>
        </section>
      ) : (
        <section className="min-h-screen p-3 pt-28 pb-12 bg-background-secondary transition-colors duration-300 overflow-x-hidden">
          <div className="flex flex-col items-center px-4">
            
            {/* Back Button Padronizado */}
            <div className="w-full max-w-6xl mb-8 flex justify-start lg:ml-8">
              <Link to="/TPQVS">
                <button className="btn-back inline-flex items-center">
                  <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                  </svg>
                  {t("elements.back")}
                </button>
              </Link>
            </div>

            {/* Layout de Conteúdo */}
            <div className="flex flex-col lg:flex-row justify-center items-center lg:items-start gap-12 lg:gap-20 w-full max-w-6xl">
              
              {/* Container da Tabela com Scale */}
              <div className="w-fit flex justify-center md:pt-4">
                <div className="grid grid-cols-2 text-center gap-0 transform scale-110 md:scale-125 lg:scale-135 origin-top transition-transform duration-300">
                  {renderColumn(elements, 17, 21, false, 0, handleElementClick, setSelectedElement, true, false, false, false, false)}
                  {/* Nota: Adicionei os argumentos faltantes no renderColumn para evitar erros de undefined */}
                </div>
              </div>

              {/* Card de Texto Informativo Padronizado */}
              <div className="w-full lg:w-2/4 p-6 bg-surface border border-border-light rounded-lg shadow-lg text-text-primary transition-colors duration-300 mt-10 lg:mt-0">
                <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-center mb-4 border-b-2 border-primary text-text-primary pb-2">
                  {t("AtomEconomy.title")}
                </h2>
                <p className="text-xs sm:text-sm md:text-base leading-relaxed text-justify text-text-secondary">
                  {t("AtomEconomy.discretion")}
                </p>
              </div>
              
            </div>
          </div>
        </section>
      )} 
    </>
  );
}